import React, {useEffect} from 'react'
import {createMarkerClass} from './CarCustomMaker'
import {getGoogleMapsClass, IMaps} from './mapsUtil'


export interface IOverlay {
  price: number
  lat: number
  lng: number
  onClick?: () => any
}

const CarMapsOverlay = (
  {
    maps,
    price,
    lat,
    lng,
    onClick,
  }: {
    maps: IMaps
  } & IOverlay) => {

  useEffect(() => {
    const MarkerClass = createMarkerClass(getGoogleMapsClass().OverlayView)
    const marker = new MarkerClass(maps, price, { lat, lng }, onClick)
    return () => {
      marker.onRemove()
    }
  }, [lat, lng])
  return null
}
CarMapsOverlay.displayName = 'CarMapsOverlay'
export default CarMapsOverlay
